<template>
  <div>
    <page-header
      class="mb-6"
      :header-title="$t('IMPORT_WIZARD.STEP_2.TITLE')"
      :header-content="$t('IMPORT_WIZARD.STEP_2.DESC')"
    />
    <section
      class="bg-white dark:bg-slate-900 flex-1 h-full overflow-hidden -mt-1"
    >
      <ve-table
        :fixed-header="true"
        :columns="columns"
        :table-data="tableData"
        :border-around="false"
      />
      <div v-if="isLoading" class="items-center flex text-base justify-center">
        <spinner />
        <span>{{ $t('CONTACTS_PAGE.LIST.LOADING_MESSAGE') }}</span>
      </div>
    </section>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import timeMixin from 'dashboard/mixins/time';
import rtlMixin from 'shared/mixins/rtlMixin';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import { mixin as clickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
export default {
  components: { VeTable, PageHeader, MultiselectDropdown },
  mixins: [clickaway, timeMixin, rtlMixin, messageFormatterMixin],
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      parsedRows: 'importWizard/getParsedRows',
      headers: 'importWizard/getHeaders',
      mappingFields: 'importWizard/mappingFields',
      unassignedFields: 'importWizard/unassignedFields',
      assignedFields: 'importWizard/assignedFields',
      mapping: 'importWizard/getMapping',
      requiredFields: 'importWizard/requiredFields',
    }),
    tableData() {
      if (!this.parsedRows.length) {
        return [];
      }

      return [{}].concat(this.parsedRows);
    },
    columns() {
      return Object.entries(this.headers).map(([key, value]) => {
        return {
          field: key,
          key: value,
          title: value,
          fixed: 'left',
          width: 180,
          align: this.isRTLView ? 'right' : 'left',
          renderBodyCell: ({ row, column, rowIndex }) => {
            if (rowIndex === 0) {
              return (
                <MultiselectDropdown
                  hasThumbnail={false}
                  onClick={e => this.onSelect(e.id, column.key)}
                  selectedItem={{
                    id: this.mapping[column.key],
                    name: this.$t(
                      `IMPORT_WIZARD.FIELDS.${this.mapping[column.key]}`
                    ),
                    required: this.requiredFields.includes(
                      this.mapping[column.key]
                    ),
                  }}
                  options={this.unassignedFields.map(field => {
                    return {
                      id: field,
                      name: this.$t(`IMPORT_WIZARD.FIELDS.${field}`),
                      tooltip:
                        this.$te(`IMPORT_WIZARD.TOOLTIPS.${field}`) &&
                        this.$t(`IMPORT_WIZARD.TOOLTIPS.${field}`),
                      required: this.requiredFields.includes(field),
                    };
                  })}
                />
              );
            }
            return this.truncateMessage(row[column.field]?.toString() || '');
          },
        };
      });
    },
  },
  methods: {
    onSelect(internalName, documentName) {
      this.$store.commit('importWizard/SET_MAPPING', {
        [documentName]: internalName,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep
  .ve-table
  .ve-table-container
  .ve-table-content
  thead.ve-table-header
  .ve-table-header-tr
  .ve-table-header-th {
  position: static !important;
}
::v-deep .ve-table-body-td {
  word-break: break-all;
  position: static !important;
}
</style>
